module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/170-greece-8527fb01d526e8ebb5678e2a94ef2eb0.svg";